@if (templates) {
  <table>
    <caption>Text Templates</caption>
    <thead>
      <th>Template Id</th>
      <th>&nbsp;</th>
    </thead>
    <tbody>
      @for (t of templates|async; track t) {
        <tr>
          <td><a (click)="edit(t.id)">{{t.id}}</a> </td>
          <td><button class="button" (click)="delete(t.id)">Delete {{t.id}}</button></td>
        </tr>
      }
    </tbody>
  </table>
}
<a class="button" (click)="create()">New Template</a>